export const IMG_BASE_URL = "//api.kwonbaek.com";
export const IMG_URL_DEFAULT_MEMBER =
    "/storage/uploads/avatar/1629728286_foto-folgt.jpg";
